import setPatients from './setPatients';
import setMorePatients from './setMorePatients';
import reset from './reset';
import activatePatient from './activatePatient';
import setUpdatedBloodPressureReading from './setUpdatedBloodPressureReading';

export default {
  setPatients,
  setMorePatients,
  reset,
  activatePatient,
  setUpdatedBloodPressureReading,
};
